var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.331 1.54034C10.4364 1.70231 10.6166 1.8 10.8098 1.8H13.4286C13.7442 1.8 14 2.05584 14 2.37143V2.42857C14 2.74416 13.7442 3 13.4286 3H0.571428C0.255837 3 0 2.74416 0 2.42857V2.37143C0 2.05584 0.255837 1.8 0.571429 1.8H3.19017C3.38343 1.8 3.5636 1.70231 3.66905 1.54035L4.50284 0.259654C4.60829 0.0976893 4.78846 0 4.98172 0H9.01832C9.21159 0 9.39176 0.0976928 9.4972 0.259662L10.331 1.54034ZM3.24119 16C2.20023 16 1.3487 15.2105 1.3487 14.2453V4.70051C1.3487 4.38492 1.60454 4.12908 1.92013 4.12908H12.1321C12.4477 4.12908 12.7035 4.38492 12.7035 4.70051V14.2453C12.7035 15.2105 11.852 16 10.8111 16H3.24119ZM4 7.5C4 7.22386 4.22386 7 4.5 7C4.77614 7 5 7.22386 5 7.5V12.5C5 12.7761 4.77614 13 4.5 13C4.22386 13 4 12.7761 4 12.5V7.5ZM10 7.5C10 7.22386 9.77614 7 9.5 7C9.22386 7 9 7.22386 9 7.5V12.5C9 12.7761 9.22386 13 9.5 13C9.77614 13 10 12.7761 10 12.5V7.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.00acb4262cf74ecd8b540c6f73049d2a.svg";
export { ForwardRef as ReactComponent };